import { Component, Input, OnInit } from '@angular/core';
import { ListitemBuilder } from './../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from './../../../../shared/filtro/filtro.service';

@Component({
  selector: 'app-passagens-filtro',
  templateUrl: './passagens-filtro.component.html',
  styleUrls: ['./passagens-filtro.component.css']
})
export class PassagensFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor(private service: FiltroService) { }

  dealers = [];
  tipoPassagem = [];
  mes: any;

  ngOnInit() {
    this.preencherTipoPassagem();
    this.preencherDealers();
    this.carregaMes();
  }

  preencherTipoPassagem() {
    this.service.buscar('categoria_passagens')
      .then(r => { this.tipoPassagem = r.filtros; });
  }

  preencherDealers() {
    this.service.buscar('dealer')
      .then(r => { this.dealers = r.filtros; });
  }

  set TipoPassagem(id: any) { this.filtros.id_categoria_passagens = this.tratarSetDropDown(id); }
  get TipoPassagem(): any { return this.tratarGetDropDown(this.filtros.id_categoria_passagens); }

  set Dealer(id: any) { this.filtros.id_dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.id_dealer); }

  set Mes(id: any) { this.filtros.mes = this.tratarSetDropDown(id); }
  get Mes(): any { return this.tratarGetDropDown(this.filtros.mes); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  selecionaDealer() {
    this.dealers = [];

    this.preencherDealers();
  }

  private carregaMes() {
    this.mes = 
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  limparFiltros() {
    this.filtros.id = '';
    this.TipoPassagem = '';
    this.Dealer = '';
    this.Mes = '';
    this.filtros.ano = '';
  }

}
